/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Welcome_SubtitleInputs */

const en_onboarding_welcome_subtitle = /** @type {(inputs: Onboarding_Welcome_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let's get you set up. This takes about 90 seconds.`)
};

const de_onboarding_welcome_subtitle = /** @type {(inputs: Onboarding_Welcome_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lass uns alles einrichten. Das dauert etwa 90 Sekunden.`)
};

const fr_onboarding_welcome_subtitle = /** @type {(inputs: Onboarding_Welcome_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous allons tout configurer. Cela prend environ 90 secondes.`)
};

const es_onboarding_welcome_subtitle = /** @type {(inputs: Onboarding_Welcome_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vamos a configurar todo. Esto toma unos 90 segundos.`)
};

const it_onboarding_welcome_subtitle = /** @type {(inputs: Onboarding_Welcome_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniziamo a configurare il tuo account. Ci vorranno circa 90 secondi.`)
};

const nl_onboarding_welcome_subtitle = /** @type {(inputs: Onboarding_Welcome_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laten we je instellen. Dit duurt ongeveer 90 seconden.`)
};

const pl_onboarding_welcome_subtitle = /** @type {(inputs: Onboarding_Welcome_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozwól nam cię skonfigurować. To zajmuje około 90 sekund.`)
};

const fi_onboarding_welcome_subtitle = /** @type {(inputs: Onboarding_Welcome_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aloitetaan asetukset. Tämä kestää noin 90 sekuntia.`)
};

const da_onboarding_welcome_subtitle = /** @type {(inputs: Onboarding_Welcome_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lad os få dig sat op. Det tager omkring 90 sekunder.`)
};

const sv_onboarding_welcome_subtitle = /** @type {(inputs: Onboarding_Welcome_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Låt oss få dig att komma igång. Detta tar cirka 90 sekunder.`)
};

/**
* | output |
* | --- |
* | "Let's get you set up. This takes about 90 seconds." |
*
* @param {Onboarding_Welcome_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_welcome_subtitle = /** @type {((inputs?: Onboarding_Welcome_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Welcome_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_welcome_subtitle(inputs)
	if (locale === "fr") return fr_onboarding_welcome_subtitle(inputs)
	if (locale === "es") return es_onboarding_welcome_subtitle(inputs)
	if (locale === "it") return it_onboarding_welcome_subtitle(inputs)
	if (locale === "nl") return nl_onboarding_welcome_subtitle(inputs)
	if (locale === "pl") return pl_onboarding_welcome_subtitle(inputs)
	if (locale === "fi") return fi_onboarding_welcome_subtitle(inputs)
	if (locale === "da") return da_onboarding_welcome_subtitle(inputs)
	if (locale === "sv") return sv_onboarding_welcome_subtitle(inputs)
	return en_onboarding_welcome_subtitle(inputs)
});